import { render } from "./SearchWrapper.vue?vue&type=template&id=3b31af3d&scoped=true"
const script = {}

import "./SearchWrapper.vue?vue&type=style&index=0&id=3b31af3d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b31af3d"]])

export default __exports__